// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5015": "59cf926dd644","5831": "cbae784e1c9c","7916": "1d3818518fc9","8150": "3f898976fd1b",}[chunkId] + ".css"
}